<template>
    <div class="type_check_box no-trans" v-loading="loading">
        <el-dialog title="立即咨询" :visible.sync="dialogVisible" :close-on-click-modal="false"
            :close-on-press-escape="false" :before-close="handleClose">
            <div class="dialog_box">
                <div class="type_check1">

                    <div class="check_item" :class="{ 'check_item_ac': type1_ac == item.type }" v-for="(item, index) in type1"
                        :key="index" @click="handle_type1(item, index)">
                        <div class="checl_img_ac" v-if="type1_ac == item.type">
                            <img src="@/assets/img/index/legal/check_ac.png" alt="">
                        </div>
                        <div class="check_title">{{ item.title }}</div>
                        <div class="check_imgs">
                            <div class="imgs" v-if="type1_ac != item.type"><img :src="item.imgs" alt=""></div>
                            <div class="imgs" v-if="type1_ac == item.type"><img :src="item.imgs_ac" alt=""></div>
                        </div>
                    </div>
                </div>
                <div class="type_check2">
                    <el-radio v-model="type2_ac" :label="item.title" v-for="(item, index) in type2"
                        :key="index">{{ item.title }}</el-radio>
                </div>


                <div class="btn_flex">
                    <div class="bnts1" @click="handle_changes">确定</div>
                </div>
            </div>
        </el-dialog>


        <el-dialog title="选择携带订单" custom-class="carry_order_dialog" :visible.sync="dialogVisible2" :close-on-click-modal="false"
            :close-on-press-escape="false" :before-close="handleClose2">
            <div class="dialog_box2">
                <div v-if="!mobile_view">
                    <el-table :data="order_list">
                        <el-table-column prop="date" label="订单号" width="200">
                            <template slot-scope="scope">
                                 <el-radio v-model="order_ac" :label="scope.row.id">{{ scope.row.order_sn }}</el-radio>
                            </template>
                        </el-table-column>
                        <el-table-column prop="pro.title" label="服务">
                        </el-table-column>
                        <el-table-column prop="address" label="详情">
                            <template slot-scope="scope">
                                <el-button type="text" size="small" @click="$router.push('/user_order/order_detial?id='+scope.row.id)">订单详情</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div v-else class="mobile_order_list" role="radiogroup" aria-label="选择携带订单">
                    <div class="mobile_order_item" :class="{is_selected: order_ac === item.id}" v-for="item in order_list" :key="item.id">
                        <el-radio v-model="order_ac" :label="item.id">
                            <span class="mobile_order_number">订单号 {{ item.order_sn }}</span>
                            <span class="mobile_order_service">{{ (item.pro || {}).title || '订单服务' }}</span>
                        </el-radio>
                        <router-link class="mobile_order_detail" :to="'/user_order/order_detial?id='+item.id">订单详情 <i class="el-icon-arrow-right" aria-hidden="true"></i></router-link>
                    </div>
                    <div class="mobile_order_empty" v-if="!order_list.length"><i class="el-icon-document" aria-hidden="true"></i><span>暂无可携带的订单</span></div>
                </div>
                <div class="btn_flex">
                    <div class="bnts1" role="button" tabindex="0" @keydown.enter.prevent="handle_end" @keydown.space.prevent="handle_end" @click="handle_end">确定</div>
                    <div class="bnts2" role="button" tabindex="0" @keydown.enter.prevent="handleClose2" @keydown.space.prevent="handleClose2" @click="handleClose2">取消</div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'
export default {
    components: {
    },
    name: "homes",
    data() {
        return {
            loading: false,
            shop_type: 1,//1个人法务 2企业法务
            shop_type2: 1,//1预约律师 2在线委托
            order_type: '',//1法律-在线咨询 2法律-预约律师 3立即咨询 4个人法务-预约律师 5个人法务-在线委托 6企业法务-预约律师 7企业法务-在线委托
            dialogVisible: false,//显示隐藏
            type1_ac: '1',
            type1: [
                {
                    title: '简单咨询',//
                    type: 1,
                    imgs: require('../../assets/img/index/legal/check_1_1.png'),
                    imgs_ac: require('../../assets/img/index/legal/check_1_2.png'),

                },
                {
                    title: '详细咨询',
                    type: 2,
                    imgs: require('../../assets/img/index/legal/check_2_1.png'),
                    imgs_ac: require('../../assets/img/index/legal/check_2_2.png'),
                }
            ],
            type2_ac: '诉讼服务',
            type2: [
                {
                    title: '诉讼服务',//
                },
                {
                    title: '非诉讼服务',//
                }
            ],
            items: {},




            dialogVisible2: false,
            order_list: [],
            order_ac:'',
            jf_order_id:'',

        }
    },
    computed: {

    },
    watch: {

    },
    created() {
        this.get_order_list()
    },
    methods: {
        get_order_list() {
            this.loading = true
            this.$api("myOrderListCopy", {
                // status:'1',
                page: 1,
                limit: 999,
			}, "get").then((res) => {
                this.loading = false
                console.log('我的订单列表',res)
                if (res.code == 1) {
                    this.order_list = res.data.data
                     
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handleClose() {
            this.dialogVisible = false

        },
        handleClose2() {
            this.dialogVisible2 = false
            this.order_ac=0

        },


        handle_open(item, i, i2,jf_order_id) {
            console.log('item', item)
            console.log('i', i)
            console.log('i2', i2)
            this.shop_type = i
            this.shop_type2 = i2
            this.items = item
            if(jf_order_id){
                this.jf_order_id=jf_order_id
            }
            // shop_type:1,//1个人法务 2企业法务 i
            // shop_type2:1,//1预约律师 2在线委托 i2
            // 1法律-在线咨询 2法律-预约律师 3立即咨询 4个人法务-预约律师 5个人法务-在线委托 6企业法务-预约律师 7企业法务-在线委托	
            if (i == 1) {//个人法务
                if (i2 == 1) {//预约律师
                    this.order_type = 4
                }
                if (i2 == 2) {//在线委托
                    this.order_type = 5
                }
            }
            if (i == 2) {//企业法务
                if (i2 == 1) {//预约律师
                    this.order_type = 6
                }
                if (i2 == 2) {//在线委托
                    this.order_type = 7
                }
            }
            console.log('order_type', this.order_type)

            this.dialogVisible = true
        },
        handle_changes(){
            if(this.type1_ac==1){
                this.dialogVisible2=true
            }else{
                this.order_ac=0
                this.handle_end()
            }
        },
        handle_end() {
            if (this.type2_ac == '诉讼服务') {
                this.$router.push({
                    path: '/legal_lawyer_index',
                    query: {

                        title_num: this.type1_ac,//1简单咨询 2详情咨询
                        type2_ac: 1,//1诉讼服务 2非诉讼服务
                        pro_id: this.items.id,
                        order_type: this.order_type,
                        lawyer_id: this.$route.query.lawyer_id || 0,
                        order_id:this.order_ac||'',
                        jf_order_id:this.jf_order_id||''

                    }
                })
            }
            if (this.type2_ac == '非诉讼服务') {

                this.$router.push({
                    path: '/no_legal_lawyer_index',
                    query: {
                        title_num: this.type1_ac,//1简单咨询 2详情咨询
                        type2_ac: 2,//1诉讼服务 2非诉讼服务
                        pro_id: this.items.id,
                        order_type: this.order_type,
                        lawyer_id: this.$route.query.lawyer_id || 0,
                        order_id:this.order_ac||'',
                        jf_order_id:this.jf_order_id||''
                    }
                })
            }
        },
        handle_type1(item, index) {
            this.type1_ac = item.type
        },


    },

}
</script>
<style scoped lang="less">
.type_check_box {
    /deep/.el-dialog__wrapper {
        .el-dialog {
            width: 580px;

            .el-dialog__header {
                background: #F7F7F7;
            }

            .el-dialog__body {
                .dialog_box {
                    .type_check1 {
                        width: 370px;
                        margin: auto;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        .check_item {
                            width: 158px;
                            height: 138px;
                            background: #FFFFFF;
                            border-radius: 6px 6px 6px 6px;
                            border: 1px solid #B8C4D1;
                            position: relative;
                            cursor: pointer;

                            .check_title {
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #333333;
                                text-align: center;
                                padding-top: 16px;
                            }

                            .check_imgs {
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                padding-top: 14px;

                                .imgs {
                                    width: 72px;
                                    height: 64px;
                                }
                            }

                            .checl_img_ac {
                                position: absolute;
                                right: 0;
                                bottom: 0;

                                img {
                                    width: 37px;
                                    height: 37px;
                                }
                            }
                        }

                        .check_item_ac {
                            border-color: #377CFD;
                        }
                    }

                    .type_check2 {
                        width: 370px;
                        margin: auto;
                        padding-top: 30px;
                    }


                    .btn_flex {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding-top: 67px;


                        .bnts1 {
                            width: 180px;
                            height: 40px;
                            background: #377CFD;
                            text-align: center;
                            line-height: 40px;
                            border-radius: 4px 4px 4px 4px;
                            cursor: pointer;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #FFFFFF;
                            margin-left: 20px;
                        }
                    }
                }

                .dialog_box2 {


                    .btn_flex {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding-top: 67px;


                        .bnts1 {
                            width: 100px;
                            height: 40px;
                            background: #377CFD;
                            text-align: center;
                            line-height: 40px;
                            border-radius: 4px 4px 4px 4px;
                            cursor: pointer;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #FFFFFF;
                            margin-left: 20px;
                        }
                        .bnts2{
                            width: 100px;
                            height: 40px;
                            background: #FFFFFF;
                            text-align: center;
                            line-height: 40px;
                            border-radius: 4px 4px 4px 4px;
                            cursor: pointer;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #377CFD;
                            border: 1px solid #377CFD;
                            margin-left: 20px;
                        }
                    }
                }
            }
        }
    }
}
</style>
<style scoped lang="less">
@import "../../styles/mobile-patterns.less";
@media (max-width: 1024px) {
    .type_check_box.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
    }
    .type_check_box.no-trans /deep/ .el-dialog__wrapper .el-dialog {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .type_check_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .type_check1 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin: auto;
        flex-wrap: wrap;
        gap: 8px;
    }
    .type_check_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .type_check1 .check_item {
        width: 158px;
        min-height: 44px;
        height: auto;
        border-radius: 6px 6px 6px 6px;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .type_check_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .type_check1 .check_item .check_title {
        font-size: 14px;
        padding-top: 16px;
    }
    .type_check_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .type_check1 .check_item .check_imgs {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 14px;
    }
    .type_check_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .type_check1 .check_item .check_imgs .imgs {
        width: 72px;
        height: 64px;
    }
    .type_check_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .type_check1 .check_item .checl_img_ac img {
        width: 37px;
        height: 37px;
    }
    .type_check_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .type_check2 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin: auto;
        padding-top: 16px;
    }
    .type_check_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .btn_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .type_check_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .btn_flex .bnts1 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 40px;
        line-height: 40px;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        margin-left: 16px;
    }
    .type_check_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box2 .btn_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .type_check_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box2 .btn_flex .bnts1 {
        width: 100px;
        height: 40px;
        line-height: 40px;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        margin-left: 16px;
    }
    .type_check_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box2 .btn_flex .bnts2 {
        width: 100px;
        height: 40px;
        line-height: 40px;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        margin-left: 16px;
    }
    .type_check_box.no-trans /deep/ .el-dialog__wrapper .el-dialog { .mobile-consultation-dialog(); }
    .type_check_box.no-trans /deep/ .el-dialog__wrapper .el-dialog.carry_order_dialog {
        display: flex; flex-direction: column;
        width: calc(100% - 24px); max-width: 480px;
        margin: 6vh auto 24px !important;
        max-height: 88vh; max-height: 88dvh;
        .el-dialog__header { flex-shrink: 0; padding: 18px 56px 16px 16px; border-bottom: 1px solid #edf0f4; }
        .el-dialog__headerbtn { top: 6px; right: 6px; width: 44px; height: 44px; font-size: 20px; }
        .el-dialog__body { display: flex; flex-direction: column; min-height: 0; max-height: none; padding: 0; overflow: hidden; }
        .dialog_box2 { display: flex; flex-direction: column; min-height: 0; }
        .mobile_order_list { min-height: 0; overflow-y: auto; overscroll-behavior: contain; padding: 4px 16px 12px; }
        .mobile_order_item {
            padding: 12px 0 4px; border-bottom: 1px solid #e8edf3;
            .el-radio { display: flex; align-items: flex-start; width: 100%; margin: 0; padding: 8px 0; white-space: normal; }
            .el-radio__input { flex-shrink: 0; margin-top: 2px; }
            .el-radio__inner { width: 20px; height: 20px; }
            .el-radio__label { display: block; flex: 1; min-width: 0; padding-left: 10px; }
            .mobile_order_number { display: block; font-size: 13px; line-height: 22px; color: #788494; overflow-wrap: anywhere; }
            .mobile_order_service { display: block; padding-top: 6px; font-size: 15px; line-height: 24px; color: #29384b; overflow-wrap: anywhere; }
            .mobile_order_detail { display: flex; align-items: center; justify-content: flex-end; gap: 4px; min-height: 44px; font-size: 13px; color: #377cfd; text-decoration: none; }
            &.is_selected .mobile_order_service { color: #2468e8; font-weight: 600; }
        }
        .mobile_order_empty { display: flex; flex-direction: column; align-items: center; gap: 12px; padding: 44px 0; color: #85909f; font-size: 14px; i { font-size: 32px; } }
        .dialog_box2 .btn_flex {
            flex-shrink: 0; display: grid; grid-template-columns: 1fr 1fr; gap: 12px;
            padding: 16px; padding-bottom: ~"max(16px, env(safe-area-inset-bottom))";
            border-top: 1px solid #edf0f4; background: #fff;
            .bnts1, .bnts2 { box-sizing: border-box; width: 100%; height: 46px; min-height: 46px; margin: 0; padding: 0; font-size: 15px; line-height: 44px; }
        }
    }
}
</style>
